import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import { isIOS, isSafari } from "react-device-detect";
import { useAnalyticsTracker } from "~/app/hooks/analytics/useAnalyticsTracker";
import { useNavigationStore } from "~/app/stores/navigation";
import bannerPWA from "~/assets/banner_pwa.png";
import { usePWAInstall } from "~/hooks/usePWAInstall";
import { DialogSafariInstall } from "./DialogSafariInstall";

// Helper to detect iOS but not Safari (for non-Safari iOS browsers)
const isIosNonSafari = () => {
  if (typeof navigator === "undefined") {
    return false;
  }
  const isStandalone = "standalone" in navigator && (navigator as any).standalone;
  return isIOS && !isSafari && !isStandalone;
};

export const AddToHomeScreen: React.FC = () => {
  const { setIsAddToHomeHeaderVisible } = useNavigationStore();
  const { isInstallable, promptToInstall } = usePWAInstall();
  const trackUI = useAnalyticsTracker("sys.ui");

  // State to trigger iOS/manual dialog for non-Safari iOS browsers
  const [showIosPrompt, setShowIosPrompt] = useState(false);
  const [open, setOpen] = useState(false);

  // Detect iOS non-Safari + not already standalone
  useEffect(() => {
    if (isIosNonSafari()) {
      setShowIosPrompt(true);
    }

    if (isInstallable || showIosPrompt) {
      setIsAddToHomeHeaderVisible(true);
    }
    // console.log("isInstallable:", isInstallable, "showIosPrompt:", showIosPrompt); // Debug
  }, [isInstallable, showIosPrompt, setIsAddToHomeHeaderVisible]);

  // Hide entirely if not installable and not on non-Safari iOS
  if (!(isInstallable || showIosPrompt)) {
    // console.log("AddToHomeScreen hidden"); // Debug
    return null;
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handlePWAInstall = () => {
    trackUI({
      screen_id: "install_pwa",
      screen_name: "web_portal",
      screen_type: "screen",
      screen_category: "web_portal",
      screen_subcategory: "web_portal",
      screen_content: isInstallable ? "prompt" : "manual_ios",
      screen_section: null,
      interaction_type: "tap",
      interaction_object: "install_pwa_button",
      interaction_object_category: "display",
      flow_name: "web_portal",
      flow_order: 2,
    });

    if (isInstallable) {
      // Chrome / Edge / Opera / iOS non-Safari browsers
      promptToInstall();
    } else {
      // Non-Safari iOS: open custom dialog
      setOpen(true);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          width: "100%",
          cursor: "pointer",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "53px",
            backgroundColor: "rgba(26, 11, 43, 1)",
            color: "#FFFFFF",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
            zIndex: 1199,
            boxShadow: 3,
            textAlign: "center",
            position: "fixed",
            // top: yPosition, //isMobile ? "64px" : "0",
            bottom: 0,
          }}
        >
          {/** biome-ignore lint/a11y/useKeyWithClickEvents: needs a click event for accessibility */}
          <img
            src={bannerPWA}
            style={{ height: "53px" }}
            alt="Add to Home Screen"
            onClick={() => {
              handlePWAInstall();
            }}
          />
        </Box>
      </Box>

      <DialogSafariInstall open={open} onClose={handleClose} />
    </>
  );
};
